import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, map } from 'rxjs';
import { basePath } from 'src/environments/environment';

const DEBUG_PATH = '/_debug'

@Injectable()
export class ApiDebugService {
  constructor(private readonly httpClient: HttpClient) { }

  public reportCount(documentId: string): Observable<number> {
    return this.httpClient.get<string>(`${basePath}${DEBUG_PATH}/${documentId}/reportCount`).pipe(map(response => Number.parseInt(response, 10)));
  }

  public metadata(documentId: string): Observable<Record<string, unknown>> {
    return this.httpClient.get(`${basePath}${DEBUG_PATH}/${documentId}/meta`) as any;
  }

  public clearCache() {
    return this.httpClient.get(`${basePath}${DEBUG_PATH}/clearCache`);
  }

  public getPath(documentId: string): Observable<string> {
    return this.httpClient.get<string>(`${basePath}${DEBUG_PATH}/path`, {
      params: {
        documentId: documentId
      }
    });
  }
}
